import classes from "./index.module.scss";
export default function Title({ children, center = true, className = "" }) {
  return (
    <h2
      className={`${classes.title} ${center ? classes.title_center : ""} ${
        className ? className : ""
      }`}
    >
      {children}
    </h2>
  );
}
